import { render, staticRenderFns } from "./InfoSectionList.vue?vue&type=template&id=1bc1182c&scoped=true"
import script from "./InfoSectionList.vue?vue&type=script&lang=js"
export * from "./InfoSectionList.vue?vue&type=script&lang=js"
import style0 from "./InfoSectionList.vue?vue&type=style&index=0&id=1bc1182c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1182c",
  null
  
)

export default component.exports